import { FAQS } from 'apps/customer/src/constants';
import { AccordionLink } from './AccordionLink';

export const QuestionsElements = ({ searchTerm }: { searchTerm: string }) => {
  const filteredFaqs = FAQS.filter((FAQ) =>
    searchTerm
      ? FAQ.question.toLowerCase().includes(searchTerm.toLowerCase())
      : []
  );

  const FAQsElement = filteredFaqs.map((FAQ, index) => {
    return (
      <AccordionLink
        key={`${index}`}
        title={FAQ.question}
        link={`?faq=${index + 1}`}
      />
    );
  });
  return FAQsElement;
};
